import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isGeneratedSvg: false,
    aiGeneratedSvg: '',
}

export const aiWriteSlice = createSlice({
    name: 'aiWrite',
    initialState,
    reducers: {
        addAiWrite2Store: (state, action) => {
            state.aiGeneratedSvg = action.payload
            state.isGeneratedSvg = true
        },
        clearAiWriteStore: (state) => {
            state.aiGeneratedSvg = ''
            state.isGeneratedSvg = false
        },
    }
})

export const { addAiWrite2Store, clearAiWriteStore } = aiWriteSlice.actions

export default aiWriteSlice.reducer
